// extracted by mini-css-extract-plugin
export default {"periodLabel":"V53ec","matchPeriodLabel":"s4Ou9"};